/**
 * HWC — Mega menü alt kategori ürünleri.
 *
 * Mega menüde bir koleksiyon bağlantısının üzerine gelindiğinde, sağdaki ürün
 * kartlarını o koleksiyonun ürünleriyle değiştirir. İmleç menüden ayrılınca
 * üst kategorinin varsayılan ürünlerine geri döner.
 *
 * Ürünler sayfa yüklenirken değil, ilk hover'da <kök>/collections/<handle>?view=menu
 * adresinden çekilir ve önbelleğe alınır; sayfa ağırlığı artmaz.
 *
 * <kök> = routes.root_url (TR'de "/", EN'de "/en"). Dil ön eki olmadan istenirse
 * Shopify birincil dili döndürür ve İngilizce sitede Türkçe ürün adları çıkar.
 */
(function () {
  if (window.__hwcMegaMenuProducts) return;
  window.__hwcMegaMenuProducts = true;

  var HOVER_DELAY = 90;
  var DEFAULT_KEY = '__default__';

  var cache = new Map();
  var timers = new WeakMap();
  var dirty = new Set();

  function localeRoot(list) {
    var root =
      (list && list.getAttribute('data-hwc-root')) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      '/';
    return root.replace(/\/+$/, '');
  }

  function fetchItems(root, handle) {
    if (!handle) return Promise.resolve('');
    var key = root + '|' + handle;
    if (cache.has(key)) return cache.get(key);
    var request = fetch(root + '/collections/' + encodeURIComponent(handle) + '?view=menu', {
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .catch(function () {
        return '';
      });
    cache.set(key, request);
    return request;
  }

  function stateOf(list) {
    if (!list.__hwcState) {
      list.__hwcState = {
        defaultHTML: list.innerHTML,
        classNames: Array.prototype.map.call(list.children, function (li) {
          return li.className;
        }),
        current: DEFAULT_KEY,
      };
    }
    return list.__hwcState;
  }

  function listInGrid(grid) {
    return grid ? grid.querySelector('[data-hwc-menu-products]') : null;
  }

  function replaceChildren(list, nodes) {
    if (typeof list.replaceChildren === 'function') {
      list.replaceChildren.apply(list, nodes);
      return;
    }
    list.innerHTML = '';
    nodes.forEach(function (node) {
      list.appendChild(node);
    });
  }

  function apply(list, handle, html) {
    var state = stateOf(list);
    if (state.current === handle) return;

    var template = document.createElement('template');
    template.innerHTML = (html || '').trim();
    var items = Array.prototype.slice.call(template.content.children);
    if (!items.length) return;

    if (state.classNames.length) items = items.slice(0, state.classNames.length);
    items.forEach(function (li, index) {
      if (state.classNames[index] != null) li.className = state.classNames[index];
    });

    replaceChildren(list, items);
    state.current = handle;
    dirty.add(list);
  }

  function reset(list) {
    var state = stateOf(list);
    if (state.current === DEFAULT_KEY) return;
    list.innerHTML = state.defaultHTML;
    state.current = DEFAULT_KEY;
    dirty.delete(list);
  }

  function schedule(list, callback) {
    clearTimeout(timers.get(list));
    timers.set(list, setTimeout(callback, HOVER_DELAY));
  }

  function prefetch(grid) {
    if (!grid || grid.__hwcPrefetched) return;
    grid.__hwcPrefetched = true;
    var root = localeRoot(listInGrid(grid));
    grid.querySelectorAll('[data-menu-collection]').forEach(function (link) {
      fetchItems(root, link.getAttribute('data-menu-collection'));
    });
  }

  function resetAll() {
    if (!dirty.size) return;
    Array.from(dirty).forEach(reset);
  }

  function onPointer(target) {
    if (!target || typeof target.closest !== 'function') return;

    var link = target.closest('.mega-menu__link[data-menu-collection]');
    if (link) {
      var grid = link.closest('.mega-menu__grid');
      var list = listInGrid(grid);
      if (!list) return;
      prefetch(grid);
      var handle = link.getAttribute('data-menu-collection');
      var root = localeRoot(list);
      schedule(list, function () {
        fetchItems(root, handle).then(function (html) {
          apply(list, handle, html);
        });
      });
      return;
    }

    var openGrid = target.closest('.mega-menu__grid');
    if (openGrid) {
      prefetch(openGrid);
      var openList = listInGrid(openGrid);
      if (openList) {
        schedule(openList, function () {
          reset(openList);
        });
      }
      return;
    }

    resetAll();
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      onPointer(event.target);
    },
    { passive: true }
  );

  document.addEventListener('focusin', function (event) {
    onPointer(event.target);
  });
})();
